import { rem } from 'polished'
import type { ComponentProps } from 'react'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'

const Container = styled.div`
  display: flex;
  align-items: center;
  height: ${rem(40)};
  &::after,
  &::before {
    content: '';
    flex: 1;
    border-top: 1px solid ${props => props.theme.palette.neutral.default.four};
    display: block;
  }
`

const TextContainer = styled.div`
  margin: 0 ${rem(12)};
`

interface Props {
  text: string
  size?: 'small' | 'medium' | 'large'
  weight?: ComponentProps<typeof BodyText>['weight']
  textFormat?: ComponentProps<typeof BodyText>['format']
  textColour?: ComponentProps<typeof BodyText>['colour']
}

export default function DividerWithText(props: Props) {
  const {
    size = 'medium',
    text,
    textFormat,
    weight,
    textColour = 'neutral-three',
  } = props

  return (
    <Container>
      <TextContainer>
        <BodyText
          variant={size}
          lineClamp={1}
          format={textFormat}
          colour={textColour}
          weight={weight}
        >
          {text}
        </BodyText>
      </TextContainer>
    </Container>
  )
}
